import SEO_PAGES_JSON from "./seo-pages.json";

export const SITE_URL = "https://abetglobal.com";

export const SEO_PAGES = SEO_PAGES_JSON;

const DEFAULT_TITLE = SEO_PAGES["/"]?.title;
const DEFAULT_DESCRIPTION = SEO_PAGES["/"]?.description;

export function normalizePath(pathname = "/") {
  if (!pathname || pathname === "/") return "/";
  const clean = pathname.replace(/\/+$/, "");
  return clean || "/";
}

export function canonicalUrl(pathname = "/") {
  const path = normalizePath(pathname);
  return path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

export function getSeoForPath(pathname = "/") {
  const path = normalizePath(pathname);
  const page = SEO_PAGES[path];
  // Never leak home title/description onto other routes
  if (page) {
    return {
      title: page.title,
      description: page.description,
      canonical: canonicalUrl(path),
    };
  }
  if (path === "/") {
    return {
      title: DEFAULT_TITLE,
      description: DEFAULT_DESCRIPTION,
      canonical: canonicalUrl("/"),
    };
  }
  return {
    title: "ABET",
    description:
      "ABET Global — multi-asset trading for forex, metals, energies, indices and crypto CFDs.",
    canonical: canonicalUrl(path),
  };
}
